import React from "react";
import { Calendar, Clock, MapPin, Ticket } from "lucide-react";
import {
  mapEventForDisplay,
  resolveCheckoutEventImage,
} from "../GroupDeatils/eventGroupDetailHelpers";
import {
  checkoutCard,
  checkoutSectionTitle,
  checkoutSummaryLabel,
  checkoutSummaryRow,
  checkoutSummaryValue,
} from "./checkoutUiClasses";
import {
  formatCouponDiscount,
  getDiscountedTotal,
} from "../../../utils/couponHelpers";

const OrderSummery = ({ data, singleCouponCode, PaymentDetails, event, eventImage }) => {
  const rawEvent = event?.[0];
  const isUserCreated = rawEvent?._isUserCreated;
  const display = mapEventForDisplay(rawEvent, eventImage, isUserCreated);
  const imageSrc = resolveCheckoutEventImage(rawEvent, eventImage);

  const totalAmount =
    data?.retail_price * data?.qty +
    (PaymentDetails?.retail?.tax || 0) +
    (data?.service_fee || 0);

  const displayTotal = getDiscountedTotal(totalAmount, singleCouponCode).toFixed(2);

  const sectionLabel =
    data?.tgUserSec ||
    data?.name ||
    (typeof data?.section === "string" ? data.section : null) ||
    data?.tgCType ||
    "General Admission";
  const rowLabel = data?.row || data?.tgUserRow;

  return (
    <div className="mt-6 w-full sm:mt-8 lg:mt-0 lg:max-w-md xl:max-w-md">
      <div className={`${checkoutCard} sticky top-24`}>
        <h2 className={checkoutSectionTitle}>Order Summary</h2>

        {rawEvent && (
          <div className="mb-5 pb-5 border-b border-[#1F2937]">
            <div className="aspect-[16/10] rounded-xl overflow-hidden border border-[#1F2937] mb-4 bg-[#0F172A]">
              <img
                src={imageSrc || display?.image}
                alt={display?.title || "Event"}
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.currentTarget.src =
                    "https://images.unsplash.com/photo-1449748040579-354c191a7934?w=800&q=80";
                }}
              />
            </div>
            <h3 className="text-white font-black text-sm uppercase tracking-tight leading-snug mb-3">
              {display?.title || rawEvent?.name}
            </h3>
            <div className="space-y-2 text-xs text-white/60">
              {display?.date && (
                <p className="flex items-center gap-2">
                  <Calendar className="w-3.5 h-3.5 text-red-500 shrink-0" />
                  {display.date}
                </p>
              )}
              {display?.time && (
                <p className="flex items-center gap-2">
                  <Clock className="w-3.5 h-3.5 text-red-500 shrink-0" />
                  {display.time}
                </p>
              )}
              {(display?.locationLine || display?.venue) && (
                <p className="flex items-start gap-2">
                  <MapPin className="w-3.5 h-3.5 text-red-500 shrink-0 mt-0.5" />
                  <span>{display.locationLine || display.venue}</span>
                </p>
              )}
              <p className="flex items-start gap-2 pt-1">
                <Ticket className="w-3.5 h-3.5 text-red-500 shrink-0 mt-0.5" />
                <span>
                  {sectionLabel}
                  {rowLabel ? ` · Row ${rowLabel}` : ""}
                </span>
              </p>
            </div>
          </div>
        )}

        <div className="space-y-0">
          <div className={checkoutSummaryRow}>
            <dt className={checkoutSummaryLabel}>Price/seat</dt>
            <dd className={checkoutSummaryValue}>${data?.retail_price}</dd>
          </div>
          <div className={checkoutSummaryRow}>
            <dt className={checkoutSummaryLabel}>Quantity</dt>
            <dd className={checkoutSummaryValue}>{data?.qty}</dd>
          </div>
          <div className={checkoutSummaryRow}>
            <dt className={checkoutSummaryLabel}>Service fee</dt>
            <dd className={checkoutSummaryValue}>
              ${(data?.service_fee || 0).toFixed(2)}
            </dd>
          </div>
          <div className={checkoutSummaryRow}>
            <dt className={checkoutSummaryLabel}>Discount</dt>
            <dd className="text-sm font-medium text-emerald-400">
              {formatCouponDiscount(singleCouponCode)}
            </dd>
          </div>
          <div className={checkoutSummaryRow}>
            <dt className={checkoutSummaryLabel}>Tax</dt>
            <dd className={checkoutSummaryValue}>
              ${PaymentDetails?.retail?.tax ?? "0"}
            </dd>
          </div>
          <div className={checkoutSummaryRow}>
            <dt className={checkoutSummaryLabel}>Subtotal</dt>
            <dd className={checkoutSummaryValue}>
              ${data?.retail_price} × {data?.qty} = $
              {(data?.retail_price * data?.qty).toFixed(2)}
            </dd>
          </div>
          <div className="flex items-center justify-between gap-4 pt-4 mt-2">
            <dt className="text-base font-black uppercase tracking-tight text-white">
              Total
            </dt>
            <dd className="text-xl font-black text-red-500">${displayTotal}</dd>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderSummery;
